var map = {
	"./bg-BG.json": 2387,
	"./ca-ES.json": 2388,
	"./cs-CZ.json": 2389,
	"./de-DE.json": 2390,
	"./el-GR.json": 2391,
	"./en-US.json": 1266,
	"./es-ES.json": 2392,
	"./et-EE.json": 2393,
	"./fi-FI.json": 2394,
	"./fr-FR.json": 2395,
	"./he-IL.json": 2396,
	"./it-IT.json": 2397,
	"./ja-JP.json": 2398,
	"./ko-KR.json": 2399,
	"./nb-NO.json": 2400,
	"./nl-NL.json": 2401,
	"./nn-NO.json": 2402,
	"./pl-PL.json": 2403,
	"./pt-BR.json": 2404,
	"./ro-RO.json": 2405,
	"./ru-RU.json": 2406,
	"./sk-SK.json": 2407,
	"./sv-SE.json": 2408,
	"./tr-TR.json": 2409,
	"./zh-CN.json": 2410
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2386;